











































import Vue from 'vue'
import _ from 'lodash'
import {
  CALENDAR_EVENT_ASSISTANT_INIT_FROM_PAYLOAD,
  CALENDAR_EVENT_ASSISTANT_RESET_STATE,
  CALENDAR_EVENT_ASSISTANT_SET_EMPLOYEE_LIST_FOR_PLANNING,
  CALENDAR_EVENT_ASSISTANT_SET_FILTERED_EMPLOYEES_BY_DEPARTMENT,
  CALENDAR_EVENT_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST,
  CREATE_CALENDAR_EVENT, EDIT_CALENDAR_EVENT,
  FETCH_AVAILABLE_EMPLOYEES_FOR_PLANNING
} from '@/store/action-types'
import {
  CALENDAR_EVENT_ASSISTANT_GET_CALENDAR_EVENT_ITEM,
  CALENDAR_EVENT_ASSISTANT_GET_COMPANY_FILTER,
  CALENDAR_EVENT_ASSISTANT_GET_END_DATE,
  CALENDAR_EVENT_ASSISTANT_GET_INITIAL_EMPLOYEE_LIST,
  CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY,
  CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST,
  CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY_SERIE,
  CALENDAR_EVENT_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST,
  CALENDAR_EVENT_ASSISTANT_GET_START_DATE,
  GET_SELECTED_UI_LANGUAGE
} from '@/store/getter-types'
import ProgressCircular from '@/components/ProgressCircular.vue'
import CalendarEventEditorStartEnd from '@/components/planning/calendar-event/CalendarEventEditorStartEnd.vue'
import { CalendarEvent } from '@/model/planning/CalendarEvent'
import { ActionsEnum } from '@/types/enums'
import { Employee } from '@/model/companyStructure/Employee'
import { ShiftEditorPlanningPayload } from '@/model/planning/ShiftEditorPlanningPayload'
import {
  CompanyFilterValue, CreateCalendarEventSeriesRequest,
  FetchEmployeeListForPlanningPayload, MitarbeiterBeschreibung,
  PlanningAssistantPeriodicityPayload, UpdateCalendarEventSeriesRequest
} from '@/types/payload'
import { EmployeeAvailableForPlanning } from '@/model/planning/EmployeeAvailableForPlanning'
import CalendarEventEditorPeriodicity from '@/components/planning/calendar-event/CalendarEventEditorPeriodicity.vue'
import {
  CalendarEventSerie,
  CreateCalendarEventSeriesResponse, KalenderArtVeranstaltungen,
  KalenderEventsCategorize
} from '@/types/service-response'
import CalendarEventEditorEmployee from '@/components/planning/calendar-event/CalendarEventEditorEmployee.vue'
import { CalendarEventEmployee } from '@/model/calendarEvent/CalendarEventEmployee'
import CalendarEventEditorFinish from '@/components/planning/calendar-event/CalendarEventEditorFinish.vue'
import moment from 'moment'
import CalendarEventEditorAdditionalInformation
  from '@/components/planning/calendar-event/CalendarEventEditorAdditionalInformation.vue'
import { PeriodicityPlannedCalendarEventEmployee } from '@/types'

interface ComponentData {
  loading: boolean
  isSaveButtonDisabled: boolean
}

export default Vue.extend({
  name: 'CalendarEventEditor',

  components: {
    ProgressCircular,
    CalendarEventEditorStartEnd,
    CalendarEventEditorPeriodicity,
    CalendarEventEditorEmployee,
    CalendarEventEditorAdditionalInformation,
    CalendarEventEditorFinish
  },

  props: {
    showDialog: Boolean,
    calendarEventEditorPayload: {
      type: Object as () => ShiftEditorPlanningPayload
    },
    action: {
      type: String as () => ActionsEnum
    },
    editCalendarEvent: Object as () => CalendarEvent | undefined,
    editCalendarEventSerie: Object as () => CalendarEventSerie | undefined,

    filteredEmployees: {
      type: Array as () => Array<Employee>
    }
  },

  data (): ComponentData {
    return {
      loading: false,
      isSaveButtonDisabled: false
    }
  },

  computed: {
    companyFilter (): CompanyFilterValue {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_COMPANY_FILTER]
    },

    initialEmployeeList (): Employee[] {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_INITIAL_EMPLOYEE_LIST]
    },

    dateStart (): Date {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_START_DATE]
    },

    dateEnd (): Date {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_END_DATE]
    },

    periodicity (): PlanningAssistantPeriodicityPayload {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY]
    },

    selectedLanguage (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    }
  },

  methods: {
    async onCloseDialog (): Promise<void> {
      this.$emit('close')
    },

    async onSaveButtonClick (): Promise<void> {
      let employeeList: CalendarEventEmployee[] = this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]
      const calendarEventItem: KalenderEventsCategorize = this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_CALENDAR_EVENT_ITEM]

      if (this.action === ActionsEnum.CREATE && this.periodicity.isUnique) {
        const employeeIdList: number[] = employeeList.map((item: CalendarEventEmployee) => {
          return item.id!
        })

        const employeeCommentList: MitarbeiterBeschreibung[] = employeeList.map((item: CalendarEventEmployee) => {
          return {
            Mitarbeiter: item.id!,
            Beschreibung: item.comment
          }
        })

        const newPeriodicityCalendarEventPayload: CreateCalendarEventSeriesRequest = {
          Titel: calendarEventItem.text ? calendarEventItem.text : '',
          Beschreibung: '',
          Mitarbeiter: employeeIdList,
          EinmaligMitarbeiterBeschreibung: employeeCommentList,
          DatumStart: this.dateStart ? moment(this.dateStart).format('YYYY-MM-DD HH:mm').toString() : '',
          DatumEnde: this.dateEnd ? moment(this.dateEnd).format('YYYY-MM-DD HH:mm').toString() : '',
          Kategorie: calendarEventItem.id!,
          Wiederholungs: this.periodicity.repeatEveryNthWeek,
          Einmalig: this.periodicity.isUnique,
          EndAfternTimes: this.periodicity.expireAfterRepetitions,
          EndAfterDate: this.periodicity.expireAfterDate ? moment(this.periodicity.expireAfterDate).format('YYYY-MM-DD').toString() : '',
          Montag: this.periodicity.weekDayList.includes(1),
          Dienstag: this.periodicity.weekDayList.includes(2),
          Mittwoch: this.periodicity.weekDayList.includes(3),
          Donnerstag: this.periodicity.weekDayList.includes(4),
          Freitag: this.periodicity.weekDayList.includes(5),
          Samstag: this.periodicity.weekDayList.includes(6),
          Sonntag: this.periodicity.weekDayList.includes(7)
        }

        try {
          this.loading = true
          this.isSaveButtonDisabled = true
          const response: CreateCalendarEventSeriesResponse = await this.$store.dispatch(CREATE_CALENDAR_EVENT, newPeriodicityCalendarEventPayload)
          if (!response.IsError) {
            this.$emit('calendarEventStepperSuccess', response.Result ? response.Result : this.$t('success.dataHaveBeenSaved').toString())
          } else {
            this.$emit('calendarEventStepperError', response.Result ? response.Result : this.$t('errors.dataCouldNotBeSaved').toString())
          }
        } catch {
          this.$emit('calendarEventStepperError', this.$t('errors.dataCouldNotBeSaved').toString())
        } finally {
          this.loading = false
          this.isSaveButtonDisabled = false
        }
      } else {

        const periodicityEmployeeList: PeriodicityPlannedCalendarEventEmployee[] = this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST]
        employeeList = []
        periodicityEmployeeList.forEach((item: PeriodicityPlannedCalendarEventEmployee) => {
          item.employeeList.forEach((e: CalendarEventEmployee) => {
            employeeList.push(e)
          })

        })

        const selectedSerie: CalendarEventSerie[] = this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY_SERIE]

        let deletedCalendarEvents: number[] = []

        selectedSerie.forEach((item: CalendarEventSerie) => {
          item.Events.forEach((i: KalenderArtVeranstaltungen) => {
            const foundItem: CalendarEventEmployee | undefined = employeeList.find((e: CalendarEventEmployee) => e.detailId === i.ID)
            if(foundItem) {
              i.Beschreibung = foundItem.comment
            } else {
              deletedCalendarEvents.push(i.ID)
            }
          })
        })

        const payload: UpdateCalendarEventSeriesRequest = {
          Series: selectedSerie,
          DeletedEvents: deletedCalendarEvents
        }

        try {
          this.loading = true
          this.isSaveButtonDisabled = true
          const response: CreateCalendarEventSeriesResponse = await this.$store.dispatch(EDIT_CALENDAR_EVENT, payload)
          if (!response.IsError) {
            this.$emit('calendarEventStepperSuccess', response.Result ? response.Result : this.$t('success.dataHaveBeenSaved').toString())
          } else {
            this.$emit('calendarEventStepperError', response.Result ? response.Result : this.$t('errors.dataCouldNotBeSaved').toString())
          }
        } catch {
          this.$emit('calendarEventStepperError', this.$t('errors.dataCouldNotBeSaved').toString())
        } finally {
          this.loading = false
          this.isSaveButtonDisabled = false
        }
      }


    }
  },

  beforeMount (): void {
    const payload: ShiftEditorPlanningPayload = this.calendarEventEditorPayload

    this.$store.dispatch(CALENDAR_EVENT_ASSISTANT_RESET_STATE)
    this.$store.dispatch(CALENDAR_EVENT_ASSISTANT_INIT_FROM_PAYLOAD, payload)
  },

  async mounted (): Promise<void> {
    if (this.companyFilter.department) {
      const payload: FetchEmployeeListForPlanningPayload = {
        departmentId: this.companyFilter.department.id
      }

      const filteredEmployeesByDepartment: Array<Employee> = this.filteredEmployees.filter((item: Employee) => item.department === this.companyFilter.department!.id)
      this.$store.dispatch(CALENDAR_EVENT_ASSISTANT_SET_FILTERED_EMPLOYEES_BY_DEPARTMENT, filteredEmployeesByDepartment)

      const availableEmployeeForPlanning: EmployeeAvailableForPlanning[] = await this.$store.dispatch(FETCH_AVAILABLE_EMPLOYEES_FOR_PLANNING, payload)
      const employeeForPlanningList = _.intersectionBy(availableEmployeeForPlanning, this.filteredEmployees, 'id')
      this.$store.dispatch(CALENDAR_EVENT_ASSISTANT_SET_EMPLOYEE_LIST_FOR_PLANNING, employeeForPlanningList)

      if (this.initialEmployeeList.length) {
        const plannedEmployeeList: CalendarEventEmployee[] = this.initialEmployeeList
            .filter((initialEmployeeItem: Employee) => {
              return _.find(employeeForPlanningList, { id: initialEmployeeItem.id })
            })
            .map((initialEmployeeItem: Employee) => {
              const plannableEmployeeItem: EmployeeAvailableForPlanning = _.find(employeeForPlanningList, { id: initialEmployeeItem.id }) as EmployeeAvailableForPlanning

              return new CalendarEventEmployee(
                  plannableEmployeeItem.id,
                  plannableEmployeeItem.name,
                  plannableEmployeeItem.capacity,
                  plannableEmployeeItem.isFloater,
                  plannableEmployeeItem.planingGroupName,
                  '',
                  this.dateStart,
                  this.dateEnd,
                  undefined
              )
            })

        this.$store.dispatch(CALENDAR_EVENT_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, plannedEmployeeList)
      }
    }
  }
})
